import { createContext, useContext } from 'react';

export const AppStateContext = createContext({ token: null, signIn: () => {}, signOut: () => {} });
export const NetworkStateContext = createContext({ online: () => {}, offline: () => {}, isOnline: false, wsStatus: 'closed', setWSStatus: () => {} })

export const useAppStateContext = () => {
    return useContext(AppStateContext);
}

export const useNetworkStateContext = () => {
    return useContext(NetworkStateContext);
}